define('trackingService',['jquery', 'env'], function ($, env) {
	'use strict';

	var enableGA = env.applicationSettings.enableGA || false;

	var searchRegExpressions = [
		{
			regex: /\?returnUrl=\/V4\/[0-9]+\/[0-9all]+\/[0-9all]+\/(monitor)\/([0-9]+)/i,
			value: '$pupilId'
		},
		{
			regex: /\?returnUrl=\/V4\/[0-9]+\/[0-9all]+\/[0-9all]+\/review\/(class)\/([0-9]+)/i,
			value: '$pupilId'
		}
	];

	var defaultOptions = {
		trackHashChanges: false,
		tracking_id : '',
		tracking_domain: 'auto',
		schoolId: '',
		classId:''
	};

	var _options = {};
	var hasGaInstance = false;
	var _ga = {};

	var cleanupHash = function (hash) {
		return;
		if (!hash) {
			return '';
		}

		var result = '#';
		var parts = hash.substring(1).split('&');
		for (var i = 0; i < parts.length; i++) {
			var part = parts[i];
			if (part) {
				if (i > 0) {
					result = result + '&';
				}

				var pair = part.split('=');
				if (pair[0] === 'pupilId') {
					result = result + 'pupilId=$pupilId';
				} else if (pair[0] === 'pupilName') {
					result = result + 'pupilName=$pupilName';
				} else {
					result = result + part;
				}
			}
		}

		return result;
	};

	var cleanupSearch = function (search) {
		return;
		if (!search) {
			return '';
		}

		var decoded = decodeURIComponent(search);

		for (var i = 0; i < searchRegExpressions.length; i++) {
			var searchRegExpression = searchRegExpressions[i];

			if (searchRegExpression.regex.test(decoded)) {
				var needle = searchRegExpression.regex.exec(decoded);

				if (needle.length === 3) {
					var page = needle[1];
					var id = needle[2];
					var replaced = decoded.replace(page + '/' + id, page + '/' + searchRegExpression.value);

					return '?returnUrl=' + encodeURIComponent(replaced.substring(11));
				}
			}
		}

		return search;
	};

	var createPath = function (url, keepClassId) {
		return;
		//Strip token from URL
		if (url.search.indexOf('token=') !== -1) {
			return url.pathname;
		}

		//In some cases we want to keep the classid in the pathname. 
		if (keepClassId)
			return url.pathname + cleanupSearch(url.search) + cleanupHash(url.hash);

		var urlParts = url.pathname.split('/').filter(function(el) {
			return el.length !== 0;
		});

		var urlClassid;
		if (urlParts.length > 1) {
			urlClassid = Number(urlParts[1]);
		}

		//check if the urlClassid != empty
		if (urlClassid === 0 || urlClassid === null || urlClassid === undefined || isNaN(urlClassid)) {
			return url.pathname + cleanupSearch(url.search) + cleanupHash(url.hash);
		} else {
			return url.pathname.replace('/' + urlClassid, '');
		}
	};

	
	var send = function (url) {
		return;
		_ga('send', 'pageview', url);
	};

	var sendEvent = function (category, action, label) {
		return;
		_ga('send', 'event', category, action, label);
	}

	var initGaCode = function () {
		return;
		_ga('create', _options.tracking_id, _options.tracking_domain);
		_ga('set', 'anonymizeIp', true);
	};

	return {
		strip: function (url) {
			return;
			return createPath(url, false);
		},
		sendAction: function (category, action, label) {
			return;
			if (!hasGaInstance)
				throw new Error('Trackingservice must be instantiated before calling update.');

			if (enableGA)
				sendEvent(category, action, label);
		},
		sendVideoPlay: function (clipIdent) {
			return;
			if (!hasGaInstance)
				throw new Error('Trackingservice must be instantiated before calling update.');

			sendEvent('video', 'play', clipIdent);
		},
		update: function (url) {
			return;
			if (!hasGaInstance)
				throw new Error('Trackingservice must be instantiated before calling update.');
			// no param: use window
			if (url === 0 || url === null || url === undefined) {
				send(createPath(window.location,false));
			}
			// wrap string to reflect window.location
			if (typeof(url) === 'string') {
				url = { pathname: url , search: '', hash: '' };
			}
			send(createPath(url,false));
		},
		init: function (options) {
			return;
			_options = $.extend(defaultOptions, options);

			if (_options.tracking_id === null || _options.tracking_id === undefined || _options.tracking_id === '') {
				// without a tracking ID, we will not send to GA, but log to console (typically in DEV env)
				_ga = function() {
					console.warn('Would log to GA (but no tracking ID configured)', arguments);
				}
			}

			hasGaInstance = true;
			// Initialize analytics
			initGaCode();
			
			send(createPath(window.location, false));

			if (_options.trackHashChanges) {
				$(window).on('hashchange', function () {
					send(createPath(window.location, false));
				});
			}
		},
		reset: function () {
			// for use from unit test
			_options = {};
			hasGaInstance = false;
			_ga = ga;
			$(window).off();
		}
	};
});
